module.exports = __webpack_public_path__ + "img/banner_generic_top.a7f4c212.jpg";